import { useQuery } from "@tanstack/react-query";
import { getDoctorsBySearch } from "../../../services/doctors";
import { SearchCriteria } from "../../../types";

export function useDoctorsBySearch(searchCriteria: SearchCriteria & { enabled?: boolean }) {
  const { searchCriteria1, searchCriteria2, searchCriteria3, page = 0, size = 10, sort = "fullName,asc", enabled = true } = searchCriteria;

  const { data, isLoading, isError } = useQuery<{
    data: any[]; // Replace with IDoctorBasic
    totalItems: number;
    totalPages: number;
    currentPage: number;
  }>({
    queryKey: ["doctors-list", searchCriteria1, searchCriteria2, searchCriteria3, page, size, sort],
    queryFn: () => getDoctorsBySearch({ searchCriteria1, searchCriteria2, searchCriteria3, page, size, sort }),
    enabled,
  });

  return {
    doctors: data?.data || [],
    totalItems: data?.totalItems || 0,
    totalPages: data?.totalPages || 1,
    isLoading,
    isError,
  };
}